enum ApplyJBTags {
  "Updated" = "35BCA356-DE7A-4C86-95FF-2DBCDE0A14CF",
  "Deleted" = "AD0377D7-1499-4489-8BF7-080F668BC3B6",
  "Added" = "E2172EF2-6770-4767-A9E5-539C571E8E81",
}

export { ApplyJBTags };
